<template>
  <div id="report">
    <common-header title="Creative Report">
      <el-form inline :model="form" ref="creativeReportForm">
        <el-form-item
          v-for="filter in filters"
          :key="filter.value"
          :label="filter.label"
          :prop="filter.value"
        >
          <el-input
            v-if="filter.value === 'placement'"
            placeholder="placement"
            v-model="form[filter.value]"
            clearable
          >
          </el-input>
          <el-select
            v-if="filter.value !== 'placement'"
            v-model="form[filter.value]"
            :multiple="['creative'].includes(filter.value)"
            clearable
            filterable
            collapse-tags
            placeholder="Select"
            :disabled="!options[filter.value]"
          >
            <el-option
              v-for="item in filterOptions[filter.value] || options[filter.value]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template slot="btn">
        <el-button
          class="btn btn-default btn-blue"
          @click="submitForm('creativeReportForm')"
        >
          Query
        </el-button>
        <el-button
          class="btn btn-default btn-pink"
          @click="resetForm('creativeReportForm')"
        >
          Reset
        </el-button>
      </template>
    </common-header>

    <report-table :data="report"></report-table>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
import ReportTable from "@/components/pages/reports/table";
import MixFormRule from "@/components/mixins/formRule";
export default {
  data() {
    return {
      form: {
        advertiser: '',
        campaign: '',
        creative: '',
        placement: '',
      },
      filters: [
        { value: "creative_type", label: "Creative Formats" },
        { value: "advertiser", label: "Advertisers" },
        { value: "campaign", label: "Campaigns" },
        { value: "creative", label: "Creatives" },
        { value: "placement", label: "Placement" },
      ],
    };
  },
  async created() {
    await this.getOptions();
  },
  mounted() {
    this.submitForm("creativeReportForm");
  },
  computed: {
    ...mapState({
      options: (state) =>
        _.assign(state.report.options, {
          creative_type: _.map(state.creative.typeInfo, (i) => ({
            label: i.name,
            value: i.type,
          })),
        }),
      report: state => state.report.report,
    }),
    filterOptions() {
      let options = {}
 
      if (this.options.creative_type && this.options.creative_type.length) {
        options.creative = _.filter(
          this.options.creative,
          (i) => !this.form.creative_type || i.type === this.form.creative_type
        );
      }

      if (this.options.campaign && this.options.campaign.length) {
        options.creative = _.filter(
          this.options.campaign,
          (i) => !this.form.advertiser || i.advertiser === this.form.advertiser
        );
      }

      if (this.options.creative && this.options.creative.length) {
        options.creative = _.filter(
          this.options.creative,
          (i) =>
            (!this.form.advertiser || i.advertiser === this.form.advertiser) &&
            (!this.form.campaign || i.campaign === this.form.campaign) &&
            (!this.form.creative_type || i.type === this.form.creative_type)
        );
      }

      if (this.form.creative && this.form.creative.length) {
        this.form.creative = _.intersection(
          this.form.creative,
          options.creative.map((i) => i.value)
        );
      }

      return options;
    },
  },
  watch: {
    "form.advertiser"(newVal) {
      this.form.campaign = null;
    },
  },
  components: {
    CommonHeader,
    ReportTable,
  },
  mixins: [MixFormRule],
  methods: {
    ...mapActions({
      getOptions: "report/getOptions",
    }),
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const url = "/api/report/creative";
          let params = this.form;
          await store.dispatch("report/getReport", { url, params });
          if (this.report.rows.length == 0) {
            this.$notify({
              title: "No report.",
              type: "warning",
              position: "bottom-right",
              offset: 20,
            });
          } else {
            this.$notify({
              title: "Success.",
              type: "success",
              position: "bottom-right",
              offset: 20,
            });
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style></style>
